import { formatDate } from "../../../../functions/dateTime/formatDate";
import { DownloadSection } from "./DownloadSection";
import { ReportInfo } from "./ReportInfo";

export const DownloadVisitReport = ({ reportsdata }) => {
  const totalSites = reportsdata?.data ? reportsdata?.data.length : 0;
  const endDate = formatDate(reportsdata.end_date);
  const startDate = formatDate(reportsdata.start_date);

  return (
    <div className="bg-white rounded-xl shadow-sm mt-2 p-5 h-[calc(100vh-10em)]  max-lg:h-[calc(100vh-8em)] max-md:h-[calc(100vh-8em)] overflow-auto">
      {/* Report Info */}
      <ReportInfo
        totalSites={totalSites}
        endDate={endDate}
        startDate={startDate}
      />
      {/* Download Section */}
      {totalSites > 0 ? (
        <DownloadSection data={reportsdata.data} />
      ) : (
        <div className="text-center pt-8 text-gray-500">
          No visit reports found for the selected date range.
        </div>
      )}
    </div>
  );
};
